import routes from '@modules/comment/comment-routes';
import store from '@modules/comment/comment-store';

export default {
  routes,
  store,
};
